import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  /* widget-normalize use class selector to reset css */\n  && {\n    font-size: 14px;\n    font-weight: 600;\n    color: #333333;\n    padding: 0 16px;\n    margin: 0;\n    line-height: 18px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
/**
 * @public
 */

var Header = styled.h2(_templateObject());
export default Header;